import {
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import {
  ApiBlueprint,
  createApiRef,
  createFrontendModule,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';

// 1. OIDC API Ref — gibt es nicht out-of-the-box, muss selbst erstellt werden
const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({
  id: 'auth.keycloak',
});

// 2. API-Factory: erzeugt die OIDC-Client-Instanz
//    WICHTIG: provider.id MUSS 'oidc' sein (matcht Backend-Provider)
const keycloakAuthApi = ApiBlueprint.make({
  name: 'keycloak',
  params: defineParams =>
    defineParams({
      api: keycloakAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'oidc',           // ← muss zu deiner Backend-Config passen
            title: 'Keycloak',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

// 3. SignInPage: nutzt OIDC.
// UX-Entscheidung siehe ADR-0005: Default-SignInPage parametrisiert,
// klassischer Klick-Login, deutsche Texte, zentriertes Layout.
// Logo-Anzeige auf der SignInPage ist eine offene Folge-Aufgabe
// (App-Icon-Registrierung im New Frontend System) — nicht Teil von
// SignInProviderConfig.
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          align="center"
          title="Anmelden bei ABUS Backstage"
          provider={{
            id: 'keycloak-auth-provider',     // frei wählbar
            title: 'Keycloak',
            message: 'Mit eurem ABUS-Account anmelden',
            apiRef: keycloakAuthApiRef,
          }}
        />
      ),
  },
});

// 4. Beides als Frontend-Module exportieren
export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [keycloakAuthApi, signInPage],
});